import { Business as BusinessIcon } from "@mui/icons-material";
import { Avatar, Button, CircularProgress, Grid, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { RenderStates, type RenderStatesProps } from "~ui/atoms/RenderStates/RenderStates";

export interface School {
  id: string;
  bubbleId: string;
  name: string;
  memberCount: number;
  requestCount: number;
  avatarUri?: string;
}

export type SchoolsTemplateBaseProps = Pick<RenderStatesProps<School[]>, "data" | "status">;

export type SchoolsTemplateProps = SchoolsTemplateBaseProps;

export const SchoolsTemplate = ({ data, status }: SchoolsTemplateProps) => {
  return (
    <RenderStates
      data={data}
      status={status}
      empty={<Typography>No schools found</Typography>}
      error={<Typography color="error">Error loading schools</Typography>}
      pending={<CircularProgress />}
      success={(schools) => (
        <Grid container spacing={2}>
          {schools.map((school) => (
            <Grid key={school.id} size={12}>
              <Button
                component={RouterLink}
                sx={{
                  borderRadius: "4px",
                  color: "inherit",
                  justifyContent: "flex-start",
                  padding: {
                    md: "1rem",
                    sm: "0.75rem",
                    xs: "0.5rem",
                  },
                  textAlign: "left",
                  textTransform: "none",
                  width: "100%",
                }}
                to={`/admin?schoolAndDistrictSelect=${school.bubbleId}`}
                variant="text"
              >
                <Grid alignItems="center" container direction="row" gap={{ md: "2.5rem", sm: "1.5rem", xs: "1rem" }}>
                  <Grid container direction="row" size="grow">
                    <Grid>
                      <Avatar
                        slotProps={{
                          img: {
                            "aria-label": `${school.name} school avatar`,
                          },
                        }}
                        src={school.avatarUri}
                        sx={{
                          height: { md: "3.5rem", sm: "3rem", xs: "2.5rem" },
                          width: { md: "3.5rem", sm: "3rem", xs: "2.5rem" },
                        }}
                      >
                        <BusinessIcon />
                      </Avatar>
                    </Grid>
                    <Grid marginLeft={{ md: "1em", sm: "0.75em", xs: "0.5em" }}>
                      <Typography
                        component="p"
                        sx={{
                          fontSize: { md: "1.25rem", sm: "1rem", xs: "0.9rem" },
                        }}
                        variant="h6"
                      >
                        {school.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: { md: "0.875rem", sm: "0.8125rem", xs: "0.75rem" },
                        }}
                        variant="body2"
                      >
                        {school.memberCount} members • {school.requestCount} pending requests
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Button>
            </Grid>
          ))}
        </Grid>
      )}
    />
  );
};
